const editMenu = {
  en: {
    translation: {
      types_of_food: "Types of cuisine",
      foodtype_not_present: "Type of cuisine not present",
      meals_title: "Meals info",
      home_made_products: "Home-made products",
      best_products: "Special dishes",
      km0_products: "Farm-to-table products",
      add: "Add",
      menu_services_title: "Menu",
      add_food_type: "Add type of cuisine",
      your_menu: "Your menu",
      add_category: "Add category",
      add_element: "Add element",
      serving_dish: "Course",
      your_dish: "Your menu",
      dish_name: "Dish name",
      ingredients: "Ingredients",
      ingredient_name: "Ingredient name",
      is_vegan: "Vegan",
      is_vegetarian: "Vegetarian",
      is_gluten_free: "Gluten-free",
      price: "Price",
      description: "Description",
      save_menu: "Save menu",
      label_menuType: "Menu name",
      add_menuType: "Add menu type",
      featured: "Featured"
    }
  },
  it: {
    translation: {
      types_of_food: "Tipi di cucina",
      foodtype_not_present: "Tipo di cibo non presente",
      meals_title: "Info pasti",
      home_made_products: "Prodotti della casa",
      best_products: "Piatti speciali",
      km0_products: "Piatti a km0",
      add: "Aggiungi",
      menu_services_title: "Menu",
      add_food_type: "Inserisci il tipo di cucina",
      your_menu: "Il tuo menu",
      add_category: "Aggiungi categoria",
      add_element: "Aggiungi elemento",
      serving_dish: "Portata",
      your_dish: "Il tuo menu",
      dish_name: "Nome piatto",
      ingredients: "Ingredienti",
      ingredient_name: "Nome ingrediente",
      is_vegan: "Vegano",
      is_vegetarian: "Vegetariano",
      is_gluten_free: "Per celiaci",
      price: "Prezzo",
      description: "Descrizione",
      save_menu: "Salva menu",
      label_menuType: "Nome menu",
      add_menuType: "Aggiungi tipo di menu",
      featured: "Metti in evidenza"
    }
  }
};

export default editMenu;
